import React from 'react';
import { Flower, Sprout, Trees } from 'lucide-react';
export function PhilosophySection() {
  return <section className="bg-white py-[140px] px-8" id="about" data-id="element-142">
      <div className="max-w-[1000px] mx-auto text-center" data-id="element-143">
        {/* Botanical G Icon */}
        <div className="flex justify-center mb-8 section-reveal" data-id="element-144">
          <div className="font-optima font-bold text-[180px] leading-none text-charcoal relative" data-id="element-145">
            G
            <span className="absolute bottom-8 right-4 w-12 h-1 bg-gold mt-[-20px] mb-[-20px]" data-id="element-146"></span>
          </div>
        </div>

        <h2 className="font-optima font-semibold text-[40px] md:text-[48px] lg:text-[56px] text-charcoal mb-6 section-reveal stagger-1" data-id="element-147">
          Inspired by Native Flora
        </h2>

        <p className="font-optima text-[20px] text-charcoal/90 leading-[1.8] max-w-[800px] mx-auto mb-16 section-reveal stagger-2" data-id="element-148">
          At Glenlofty, our philosophy is simple: to create wines that are a
          pure and authentic expression of our unique terroir. We practice
          meticulous, sustainable viticulture focused on soil health, vine
          balance, and low yields.
        </p>

        {/* Flora Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 section-reveal stagger-3" data-id="element-149">
          <div className="flex flex-col items-center" data-id="element-150">
            <div className="w-16 h-16 rounded-full bg-sage-light flex items-center justify-center mb-4 text-sage" data-id="element-151">
              <Trees size={32} strokeWidth={1.5} data-id="element-152" />
            </div>
            <span className="font-optima text-[16px] text-charcoal/80" data-id="element-153">
              Eucalyptus & Native Forests
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-154">
            <div className="w-16 h-16 rounded-full bg-sage-light flex items-center justify-center mb-4 text-sage" data-id="element-155">
              <Flower size={32} strokeWidth={1.5} data-id="element-156" />
            </div>
            <span className="font-optima text-[16px] text-charcoal/80" data-id="element-157">
              Wildflowers & Banksia
            </span>
          </div>
          <div className="flex flex-col items-center" data-id="element-158">
            <div className="w-16 h-16 rounded-full bg-sage-light flex items-center justify-center mb-4 text-sage" data-id="element-159">
              <Sprout size={32} strokeWidth={1.5} data-id="element-160" />
            </div>
            <span className="font-optima text-[16px] text-charcoal/80" data-id="element-161">
              Golden Wattle
            </span>
          </div>
        </div>
      </div>
    </section>;
}